import { isValid, parseISO } from 'date-fns';

export const isValidDate = (value) =>
  (Object.prototype.toString.call(value) === '[object Date]' &&
    !Number.isNaN(value.getTime())) ||
  (Number.isNaN(Number(value)) &&
    isValid(parseISO(value)) &&
    !value.indexOf(',') !== -1);
